var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: _vm.bare ? "" : "form-group propertyfield",
      attrs: { id: _vm.htmlId },
    },
    [
      !_vm.bare
        ? _c(
            "label",
            {
              staticClass: "col-xs-12 col-md-3",
              attrs: { for: _vm.inputId, title: _vm.description },
            },
            [
              _vm._v(_vm._s(_vm.displayName) + " "),
              _c("Debug", [_vm._v("(id: " + _vm._s(_vm.annotation.id) + ")")]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.bare ? "" : "col-xs-12 col-md-9" },
        [
          _vm.annotation.uiType === "select"
            ? _c("SelectPicker", {
                attrs: {
                  "data-width": "100%",
                  container: "body",
                  searchable: _vm.options.length > 12,
                  placeholder: _vm.displayName,
                  "data-id": _vm.inputId,
                  "data-name": _vm.inputId,
                  "data-dir": _vm.textDirection,
                  options: _vm.options,
                },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              })
            : _vm.annotation.uiType === "lexicon"
            ? _c("Lexicon", {
                ref: "reset",
                attrs: {
                  annotationId: _vm.annotation.id,
                  definition: _vm.annotation,
                },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              })
            : _c(
                "div",
                { class: _vm.bare ? "" : "input-group" },
                [
                  _c("Autocomplete", {
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      useQuoteAsWordBoundary: "",
                      id: _vm.inputId,
                      name: _vm.inputId,
                      placeholder: _vm.displayName,
                      disabled: _vm.annotation.uiType === "pos",
                      dir: _vm.textDirection,
                      autocomplete: _vm.autocomplete,
                      url: _vm.autocompleteUrl,
                    },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.bare
                    ? _c("div", { staticClass: "input-group-btn" }, [
                        _vm.annotation.uiType === "pos"
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-default",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.posOpen = true
                                  },
                                },
                              },
                              [
                                _c("span", {
                                  staticClass: "fa fa-pencil fa-fw",
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.annotation.uiType !== "pos"
                          ? _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-default file-input-button",
                                attrs: { for: _vm.fileInputId },
                              },
                              [
                                _c("span", {
                                  staticClass: "fa fa-upload fa-fw",
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: {
                                    type: "file",
                                    title: "Upload a list of values",
                                    id: _vm.fileInputId,
                                  },
                                  on: { change: _vm.onFileChanged },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
                1
              ),
          _vm._v(" "),
          _vm.annotation.uiType === "pos"
            ? [
                _c("PartOfSpeech", {
                  ref: "reset",
                  attrs: {
                    open: _vm.posOpen,
                    id: `pos_editor${_vm.uid}`,
                    annotation: _vm.annotation,
                  },
                  on: {
                    close: function ($event) {
                      _vm.posOpen = false
                    },
                    submit: function ($event) {
                      _vm.value = $event
                    },
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.annotation.caseSensitive && !_vm.bare
            ? _c("div", { staticClass: "checkbox" }, [
                _c("label", { attrs: { for: _vm.caseInputId } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.caseSensitive,
                        expression: "caseSensitive",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                      id: _vm.caseInputId,
                      name: _vm.caseInputId,
                    },
                    domProps: {
                      checked: Array.isArray(_vm.caseSensitive)
                        ? _vm._i(_vm.caseSensitive, null) > -1
                        : _vm.caseSensitive,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.caseSensitive,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.caseSensitive = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.caseSensitive = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.caseSensitive = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("annotation.caseSensitive")) +
                      "\n\t\t\t"
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.bare && _vm.description
        ? _c(
            "div",
            { class: _vm.bare ? "" : "col-xs-12 col-md-push-3 col-md-9" },
            [
              _c("small", { staticClass: "text-muted" }, [
                _c("em", [_vm._v(_vm._s(_vm.description))]),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }